import {useLocation} from 'react-router';
import useMapMode from './useMapMode.js';

const useAppSection = () => {
  const location = useLocation();
  const {isBrowserMode} = useMapMode();

  const [basePageRaw, detailPage] = location.pathname.slice(1).split('/');
  const basePage = basePageRaw.charAt(0).toUpperCase() + basePageRaw.slice(1);

  if (isBrowserMode) {
    return {appSection: basePage, detailPage: undefined};
  }

  const appSection = [
    basePage,
    detailPage ? (detailPage === 'new' ? 'New' : 'Detail') : null,
  ]
    .filter(p => !!p)
    .join(' ');

  return {appSection, detailPage};
};

export default useAppSection;
